/*  */
import Glyph from 'components/Glyph';
import ModalMenuItem from 'components/ModalMenuItem';
import * as React from 'react';
import ReportToRemindSelectModal from 'support/components/ReportToRemindSelectModal';
import UserActions from 'user/UserActions';

type Props = {
  reportee: {
    uuid: string;
    name: string;
  };
  disabled: boolean;
};

class ReportUserMenuItem extends React.Component<Props> {
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'key' implicitly has an 'any' type.
  reportParticipant = (key, notes) => {
    UserActions.reportUser(this.props.reportee.uuid, key, notes);
  };

  renderReportDialog = () => {
    return (
      <ReportToRemindSelectModal
        reportee={this.props.reportee.name}
        notesPlaceholder="Why are you reporting this participant?"
        onReport={this.reportParticipant}
      />
    );
  };

  render() {
    return (
      <ModalMenuItem
        modal={this.renderReportDialog()}
        // @ts-expect-error ts-migrate(2783) FIXME: 'disabled' is specified more than once, so this us... Remove this comment to see the full error message
        disabled={this.props.disabled}
        {...this.props}
      >
        <Glyph name="flag" />
        <span>Report to Remind</span>
      </ModalMenuItem>
    );
  }
}

export default ReportUserMenuItem;
